define(
    "diy/undo-redo/Entry",
    [
        'diy/undo-redo/constants'
    ],
    /**
     *
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function (constants) {
        'use strict';
        var Entry;

        /**
         * @class module.undoRedo.Entry
         * @template module.undoRedo.Entry
         * @lends {module.undoRedo.Entry.prototype}
         * @constructor
         */
        Entry = Klazz.extend({
            type: constants.types.UNDO,

            isSessionHead: false,
            linkedEntryId: 0,

            /** @type {module.undoRedo.HistoryEntry.Base} */
            historyEntry: null,

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             */
            initialize: function (historyEntry) {
                this.historyEntry = historyEntry;
            },
            /**
             *
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            getHistoryEntry: function getHistoryEntry() {
                return this.historyEntry;
            },
            /**
             *
             * @param {String} session
             * @returns {module.undoRedo.Entry}
             */
            setUndoSessionId: function (session) {
                this.historyEntry.setUndoSessionId(session);
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getUndoSessionId: function () {
                return this.historyEntry.getUndoSessionId();
            },

            /**
             *
             * @param {Number} sessionIndex
             * @returns {module.undoRedo.Entry}
             */
            setSessionIndex: function (sessionIndex) {
                this.historyEntry.setSessionIndex(sessionIndex);
                return this;
            },
            /**
             *
             * @returns {number}
             */
            getSessionIndex: function () {
                return this.historyEntry.getSessionIndex();
            },
            /**
             *
             * @returns {module.undoRedo.constants.executionType.SERVER|module.undoRedo.constants.executionType.CLIENT}
             */
            getExecutionType: function () {
                return this.historyEntry.getExecutionType();
            },
            /**
             *
             * @param {module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO} type
             * @returns {module.undoRedo.Entry}
             */
            setType: function (type) {
                this.type = type;
                return this;
            },

            /**
             *
             * @returns {module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO}
             */
            getType: function () {
                return this.type;
            },

            /**
             *
             * @param {Boolean} visible
             * @returns {module.undoRedo.Entry}
             * @deprecated not used
             */
            setVisible: function (visible) {
                this.visible = visible;
                return this;
            },

            /**
             *
             * @returns {Boolean}
             * @deprecated not used
             */
            getVisible: function () {
                return this.visible;
            },

            /**
             *
             * @returns {Boolean}
             */
            isExecutable: function () {
                return !!this.historyEntry.getExecutable();
            },

            /**
             *
             * @param {String} message
             * @returns {module.undoRedo.Entry}
             */
            setMessage: function (message) {
                this.historyEntry.setMessage(message);
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getMessage: function () {
                return this.historyEntry.getMessage();
            },

            /**
             *
             * @returns {*}
             */
            getPayload: function getPayload() {
                return this.historyEntry.getPayload();
            },
            /**
             *
             * @param payload
             * @returns {module.undoRedo.Entry}
             */
            setPayload: function setPayload(payload) {
                this.historyEntry.setPayload(payload);
                return this;
            },

            /**
             *
             * @returns {String}
             */
            getLabel: function () {
                return this.historyEntry.getLabel();
            },

            /**
             *
             * @param {Number} entryId
             * @returns {module.undoRedo.Entry}
             */
            setEntryId: function (entryId) {
                this.historyEntry.setId(entryId);
                return this;
            },
            /**
             *
             * @returns {Number}
             */
            getEntryId: function () {
                return this.historyEntry.getId();
            },
            /**
             *
             * @param {String} key
             * @returns {module.undoRedo.Entry}
             */
            setKey: function (key) {
                this.historyEntry.setKey(key);
                return this;
            },

            /**
             *
             * @returns {String}
             */
            getKey: function () {
                return this.historyEntry.getKey();
            },
            /**
             *
             * @returns {String}
             */
            getManager: function () {
                return this.historyEntry.manager;
            },

            /**
             *
             * @param {Boolean} isSessionHead
             * @returns {module.undoRedo.Entry}
             */
            setIsSessionHead: function (isSessionHead) {
                if (isSessionHead === true || isSessionHead === false) {
                    this.isSessionHead = isSessionHead;
                }
                return this;
            },
            /**
             *
             * @returns {Boolean}
             */
            getIsSessionHead: function () {
                return this.isSessionHead;
            },

            setLinkedEntryId: function (linkedEntryId) {
                if (isNaN(linkedEntryId) === false) {
                    this.linkedEntryId = linkedEntryId;
                }
                return this;
            },
            /**
             *
             * @returns {Number}
             */
            getLinkedEntryId: function () {
                return this.linkedEntryId;
            },
            /**
             *
             * @param {{undo: module.undoRedo.Entry[], redo: module.undoRedo.Entry[]}} chains
             * @returns {module.undoRedo.Entry[]}
             */
            getChain: function getChain(chains) {
                var chain = [];
                switch (this.type) {
                    case constants.types.UNDO:
                        chain = chains.undo;
                        break;
                    case constants.types.REDO:
                        chain = chains.redo;
                        break;
                }
                return chain;
            },
            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {Number}
             */
            getPositionInChain: function getPositionInChain(chain) {
                return chain.indexOf(this);
            },
            /**
             * @param lastInBlock {Boolean}
             * @returns {Promise|Q.promise}
             */
            execute: function (lastInBlock) {
                var deferred = Q.defer();

                this.historyEntry
                    .execute(lastInBlock)
                    .timeout(constants.executionTimeout, constants.executionTimeoutMessage)
                    .then(
                    function (result) {
                        deferred.resolve(result);
                    },
                    function (err) {
                        // when the execute will fail or timeout ends
                        deferred.reject(err);
                    }
                );

                return deferred.promise;
            },

            /**
             * called when a server side entry was executed
             * scope: visually reflect the stated of what changed in browser
             *
             * @param {*} executionDetails
             * @returns {*}
             */
            onExecuted: function (executionDetails) {
                var deferred = Q.defer();

                if (this.isSessionHead === true) {
                    deferred.resolve(true);
                    return deferred.promise;
                }

                this.historyEntry
                    .onExecuted(executionDetails)
                    .timeout(constants.applyResultsTimeout, constants.executionTimeoutMessage)
                    .then(function (result) {
                        // when the execute will finish
                        deferred.resolve(result);
                    })
                    .catch(function (err) {
                        // when the execute will fail or timeout ends
                        deferred.reject(err);
                    });
                return deferred.promise;
            },

            /**
             * called when a server side entry was executed and is the entry required to be executed (lastEntry)
             * scope: visually reflect the stated of what changed in browser
             */
             onExecutedLast: function (executionDetails) {
                if (!this.isSessionHead) {
                    this.historyEntry.onExecutedLast(executionDetails);
                }
            },

            /**
             * called for client side entries to create snapshot
             *
             * @param {Object=} data
             * @returns {Promise|Q.promise}
             */
            createSnapshot: function (data) {
                return this.historyEntry.createSnapshot(data);
            },
            /**
             *
             * @returns {{manager: String, message: String, isExecutable: Boolean, payload: Object, type: (module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO), undoSessionId: String, undoSessionIndex: number, entryId: Number}}
             */
            toDatabase: function () {
                return {
                    manager: this.getManager(),
                    message: this.getMessage(),
                    isExecutable: this.isExecutable(),
                    payload: this.historyEntry.serialize(),
                    type: this.getType(),
                    undoSessionId: this.getUndoSessionId(),
                    undoSessionIndex: this.getSessionIndex(),
                    entryId: this.getEntryId()
                };
            },

            /**
             * called when user selects an entry in interface
             */
            onSelect: function () {
                this.historyEntry.onSelect();
            },

            /**
             * called when user deselects an entry in interface
             */
            onDeselect: function () {
                this.historyEntry.onDeselect();
            },

            /**
             * called when entry is deleted
             * @deprecated not implemented; not required yet
             */
            onDelete: function () {
                this.historyEntry.onDelete();
            },

            /**
             * called when entry is deleted
             * @deprecated not implemented; not required yet
             */

            onInsert: function () {
                this.historyEntry.onInsert();
            },
            /**
             * Used to get the unique identity for client entries (same object, same action, etc.. )
             *
             * if result is not null, should return entity-based identifier that will be
             *  used for grouping full snapshots entries
             *
             * @returns {*}
             */
            getIdentity: function () {
                if (typeof this.historyEntry.getIdentity === 'function') {
                    return this.historyEntry.getIdentity();
                }
                return null;
            },

            /**
             * scope: visually apply data on client; !! no save
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            applySnapshot: function applySnapshot(snapshot) {
                return this.historyEntry.applySnapshot(snapshot);
            },
            /**
             * scope: apply data from payload to the server
             *
             * @returns {Promise|Q.promise}
             */
            submit: function submit() {
                return this.historyEntry.submit();
            }
        });

        return Entry;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Entry.js
 ** module id = 897
 ** module chunks = 0
 **/